import { Route, Routes } from "react-router-dom";
import Lessons from "./Lessons";

export default function LessonsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Lessons />} />
    </Routes>
  );
}